var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 4,
    viewBox: "0 0 5 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_drop_down_24px",
    opacity: 0.6,
    d: "M0.206446 1.6463L2.00994 3.76116C2.28151 4.07961 2.7202 4.07961 2.99177 3.76116L4.79527 1.6463C5.23396 1.13187 4.92061 0.25 4.30087 0.25H0.693878C0.0741434 0.25 -0.232242 1.13187 0.206446 1.6463Z",
    fill: "#637083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.41ecb42b6cad13254661adb8097bbc34.svg";
export { ForwardRef as ReactComponent };